import React from "react";

const Input = (props) => {
  const {
    id,
    label,
    type,
    customFront,
    className,
    name,
    value,
    error,
    placeholder,
    readOnly,
    onChange,
    disabled,
    hidden,
  } = props;
  return (
    <div className="mb-3">
      {label && (
        <label
          className="form-label"
          htmlFor={id}
          dangerouslySetInnerHTML={{ __html: label }}
        ></label>
      )}
      {type === "date" || type === "datetime-local" || type === "time" ? (
        <div className={customFront && "d-flex"}>
          {customFront && <span className="mr-1 mt-1">{customFront}</span>}
          <input
            className={`form-control form-control-custom ${className} ${error && "is-invalid"}`}
            onChange={onChange}
            onFocus={onChange}
            onMouseUp={onChange}
            onPaste={onChange}
            type={type}
            name={name}
            defaultValue={value}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            hidden={hidden}
            id={id}
          />
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      ) : (
        <div className={customFront && "d-flex"}>
          {customFront && <span className="mr-1 mt-1">{customFront}</span>}
          <input
            className={`form-control form-control-custom ${className} ${error && "is-invalid"}`}
            onKeyUp={onChange}
            onChange={onChange}
            onFocus={onChange}
            onPaste={onChange}
            type={type}
            name={name}
            defaultValue={value}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            hidden={hidden}
            id={id}
          />
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      )}
      <div className="invalid-feedback">{error}</div>
    </div>
  );
};

export default Input;
